module.exports = __webpack_public_path__ + "img/ic_shijijingyingren.31d0e47e.svg";